import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { postPasswordResetLink } from '../../../api/auth'

const ForgortPassword = () => {
  const route = all_routes
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    setError('')
    setIsLoading(true)

    try {
      await postPasswordResetLink({ email })
      navigate(route.emailVerification)
    } catch (error) {
      setError(
        error.response?.data?.message ||
          'Terjadi kesalahan. Silakan coba lagi.',
      )
    } finally {
      setIsLoading(false)
    }
  }
  // const loginSLider = {
  //   dots: true,
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   adaptiveHeight: true,
  //   // autoplay: true, // Uncomment if needed
  // };

  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper">
        <div className="login-content">
          <div className="row">
            {/* Login Banner */}
            <div className="col-md-6 login-bg d-none d-lg-flex p-5">
              <div className="login-carousel-section mb-3">
                <div className="login-banner">
                  <ImageWithBasePath
                    src="/assets/img/login.webp"
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div
                  className="mentor-course text-center mt-5"
                  style={{ color: '#1E344C' }}
                >
                  <h3 className="mb-2" style={{ color: '#1E344C' }}>
                    Assalamu’alaikum,
                    <br />
                    <span className="" style={{ color: '#1E344C' }}>
                      Welcome to Jadipraktisi!
                    </span>
                  </h3>
                  <p className="" style={{ color: '#1E344C' }}>
                    Bismillah, perjalanan karirmu akan dimulai dari sini, masuk
                    sekarang!
                  </p>
                </div>
              </div>
            </div>
            {/* /Login Banner */}
            <div className="col-md-6 login-wrap-bg">
              {/* Login */}
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="w-100">
                    <div className="d-flex align-items-center justify-content-between login-header">
                      <Link to={route.home} className="link-1">
                        <ImageWithBasePath
                          src="/assets/img/logo-color.webp"
                          className="img-fluid"
                          alt="Logo"
                          width={250}
                        />
                      </Link>
                    </div>
                    <div className="topic">
                      <h1 className="fs-32 fw-bold mb-3">Forgot Password</h1>
                      <p className="fs-14 fw-normal mb-0">
                        Enter your email to reset your password.
                      </p>
                    </div>
                    <form onSubmit={handleSubmit} className="mb-3 pb-3">
                      {error && (
                        <div className="alert alert-danger" role="alert">
                          {error}
                        </div>
                      )}
                      <div className="mb-3 position-relative">
                        <label className="form-label">
                          Email<span className="text-danger ms-1">*</span>
                        </label>
                        <div className="position-relative">
                          <input
                            type="email"
                            className="form-control form-control-lg"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={isLoading}
                          />
                          <span>
                            <i className="isax isax-sms input-icon text-gray-7 fs-14" />
                          </span>
                        </div>
                      </div>
                      <div className="d-grid">
                        <button
                          className="btn btn-secondary btn-lg"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Mengirim...
                            </>
                          ) : (
                            <>
                              Submit
                              <i className="isax isax-arrow-right-3 ms-1" />
                            </>
                          )}
                        </button>
                      </div>
                    </form>
                    <p className="fs-14 fw-normal d-flex align-items-center justify-content-center">
                      Remember Password?
                      <Link to={route.login} className="link-2 ms-1">
                        {' '}
                        Sign In
                      </Link>
                    </p>
                    {/* /Login */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  )
}

export default ForgortPassword
